// extracted by mini-css-extract-plugin
export default {"inputs":"YourName_inputs__47D3w","skeletonLoadingAnimation":"YourName_skeletonLoadingAnimation__1MHCO"};